import { useMemo } from "react";
import { FileGalleryListingItem } from "~/components/layout/gallery/FileGalleryListingItem";
import { ListingGroup } from "~/components/layout/ListingGroup";
import { Only } from "~/components/permission/Only";
import { useGallery } from "~/providers/GalleryProvider";

export type BasicGalleryProps = {
    images?: string[];
};

export const BasicGallery = ({ images }: BasicGalleryProps) => {
    const { findMedia } = useGallery();

    const items = useMemo(() => (images ?? []).map((p) => findMedia(p)).filter((i) => !!i), [images, findMedia]);

    return (
        <Only when={items.length}>
            <ListingGroup>
                {items.map((item, idx, array) => (
                    <FileGalleryListingItem item={item} key={item.id} last={idx === array.length - 1} />
                ))}
            </ListingGroup>
        </Only>
    );
};
